import { render, staticRenderFns } from "./XcxManageModal.vue?vue&type=template&id=736ffea2&scoped=true&"
import script from "./XcxManageModal.vue?vue&type=script&lang=js&"
export * from "./XcxManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ffea2",
  null
  
)

export default component.exports